import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutRequest } from '@ackee/petrus';

import { useUIMessage } from 'modules/ui';

import { logoutApiSelector } from '../services/selectors';
import { SALESFORCE_ACCESS_TOKEN_STORAGE_KEY } from '../constantsSalesforce';

const MANUAL_LOGOUT_FLAG = 'manual_logout_requested';

function clearAuthTokens() {
    try {
        localStorage.removeItem(SALESFORCE_ACCESS_TOKEN_STORAGE_KEY);
        for (const key of Object.keys(localStorage)) {
            if (key.startsWith('CognitoIdentityServiceProvider')) {
                localStorage.removeItem(key);
            }
        }
    } catch {
        // ignore
    }
}

export const useLogout = () => {
    const dispatch = useDispatch();

    return () => {
        clearAuthTokens();
        try {
            sessionStorage.setItem(MANUAL_LOGOUT_FLAG, 'true');
        } catch {
            // ignore
        }
        dispatch(logoutRequest());
    };
};

export const useLogoutMessage = () => {
    const message = useUIMessage();
    const { success, error } = useSelector(logoutApiSelector);

    useEffect(() => {
        if (success) {
            let manual = false;
            try {
                manual = sessionStorage.getItem(MANUAL_LOGOUT_FLAG) === 'true';
                sessionStorage.removeItem(MANUAL_LOGOUT_FLAG);
            } catch {
                manual = false;
            }

            if (manual) {
                message('info', 'auth.logout.success');
            }
        }
    }, [success, message]);

    useEffect(() => {
        if (error) {
            message('error', 'auth.logout.error');
        }
    }, [error, message]);
};
